module.exports = __webpack_public_path__ + "static/media/TextBlue (3).4f9f0f33.svg";